import React from "react";
import {
  // FButton,
  // FCard,
  FContainer,
  // FGrid,
  // FGridItem,
  // FItem,
  // FResponseBar,
  // FTypo,
} from "ferrum-design-system";
import { UnWrap as CrucibleUnWrap } from "./UnWrapCard";
import CrucibleFeeCard from "../common/CrucibleFeeCard";
import { CrucibleMyBalance } from "../../../common/CardMyBalance";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/rootReducer";

export const UnWrap = () => {
  const { theme } = useSelector((state: RootState) => state.config);
  // const [unwrap, setUnwrap] = useState(false);
  // const [flowType, setFlowType] = useState("");

  return (
    <div className="justify_center align_start d-flex min-100vw new-design-container-paddings-lr">
      <div className="custom-mr-50">
        <CrucibleUnWrap />

        {!theme.crucibleConfig?.isCustomClaimEnabled && <CrucibleFeeCard /> }
      </div>
      <div>
        <CrucibleMyBalance />
      </div>
    </div>
  );
};
